<template>
  <Modal>
    <Modal.Title>{{ content.title }}</Modal.Title>
    <Modal.Body>
      <AccountClosureInfoBody :mode="mode" />
    </Modal.Body>
    <Modal.Footer layout="vertical">
      <Button
        variant="danger"
        @click="handlePrimary"
      >
        {{ primaryLabel }}
      </Button>
      <Button variant="stroke" @click="handleKeep">
        {{ content.secondary }}
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Modal, Button } from '@dacr/library'

import { openModal, Modals, closeAllModals } from '@/shared/dialogs/modals'
import { closeAllSheets } from '@/shared/dialogs/sheets'
import AccountClosureInfoBody from './AccountClosureInfoBody.vue'
import { closureContent, type ClosureMode } from '../content'
import { useOutstandingBalance } from '../useOutstandingBalance'

const props = defineProps<{ mode: ClosureMode }>()

const { hasOutstandingBalance } = useOutstandingBalance()

const content = computed(() => closureContent[props.mode].info)
const primaryLabel = computed(() =>
  hasOutstandingBalance.value
    ? content.value.primaryWithBalance
    : content.value.primaryNoBalance
)

const handlePrimary = () =>
  openModal(Modals.ConfirmAccountClosure, { props: { mode: props.mode } })

const handleKeep = () => {
  closeAllModals()
  closeAllSheets()
}
</script>
